import Table from 'react-bootstrap/Table'

function ViewReglamento({selectedReglamento}) {
    return (
        <Table striped bordered hover>
            <tbody>
                <tr>
                    <th>Tipo</th>
                    <td>{selectedReglamento.tipo}</td>
                </tr>
                <tr>
                    <th>Número</th>
                    <td>{selectedReglamento.numero}</td>
                </tr>
                <tr>
                    <th>Activo</th>
                    <td>{selectedReglamento.activo ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <th>Fecha de Creación</th>
                    <td>{selectedReglamento.fecha_creacion}</td>
                </tr>
            </tbody>
        </Table>
    )
}

export default ViewReglamento